<!-- Explore -->
<oth-hero [contents]="exploreTitle"></oth-hero>
<ng-container *ngFor="let companyProduct of COMPANIES">
    <ng-container *ngIf="companyProduct.key === 2">
        <div class="cards-wrapper">
            <ng-container *ngFor="let product of companyProduct.products[0].products">
                <app-presentation-card [class]="product.color ? product.color : ''"
                    [href]="product.redirectToUrl ? product.url : (URLS.product + '/' + product.key)" [imgHeight]="168"
                    [imgWidth]="168" [maintenance]="product.url === URLS.maintenance"
                    [secondaryText]="product.description" [src]="product.logo" [title]="product.name"
                    class="related-product">
                </app-presentation-card>
            </ng-container>
        </div>
    </ng-container>
</ng-container>